import _each from 'lodash/each';
import _sortBy from 'lodash/sortBy';
import _reduce from 'lodash/reduce';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _extend from 'lodash/extend';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $rootScope, $timeout, $state, $stateParams, $location, utilsService, metaTagService, loggerService, tracking, membershipService, jsSdkMembership, jsSdkCity, jsSdkUser) {
  if ($scope.isSubscribed()) {
    $state.go('app.membership.perks');

    return;
  }

  metaTagService.set({
    title: 'Start Membership | Tablelist',
    description: 'Receive exclusive member only perks and experiences at your favorite nightclubs, lounges, and events.'
  });

  $scope.paymentProfile = {};

  $scope.plans = [];
  $scope.plan = {};
  $scope.discountApplied = false;
  $scope.showDiscountForm = false;
  $scope.discountErrorMessage = null;
  $scope.membershipDiscountForm = {
    promoCode: null
  };

  $scope.toggleDiscountForm = function($event) {
    if ($event) $event.preventDefault();

    $scope.showDiscountForm = !$scope.showDiscountForm;
  };

  if ($location.search && $location.search().promo) {
    $scope.showDiscountForm = true;
    $scope.membershipDiscountForm.promoCode = $location.search().promo;
  }

  $scope.selectPlan = function(plan, $event) {
    if ($event) $event.preventDefault();

    $scope.plan = plan;

    $scope.purchasingErrorMessage = null;
  };

  $scope.changePlan = function($event) {
    if ($event) $event.preventDefault();

    $scope.plan = null;
  };

  $scope.loadingPlans = true;

  $scope.membershipListPromise
    .then(resp => {
      $scope.loadingPlans = false;

      _each(resp, plan => {
        plan.terms = plan.terms.map(term => {
          return {
            title: term,
            accepted: false
          };
        });
      });

      $scope.plans = _sortBy(resp, 'billingPrice');
    })
    .catch(() => {
      $scope.loadingPlans = false;
    });

  $scope.redeemDiscount = function(form, $event) {
    if ($event) $event.preventDefault();

    $scope.discountFormSubmitted = true;
    $scope.discountErrorMessage = null;
    $scope.discountApplied = false;

    if (!form.$valid) {
      return null;
    }

    const planId = $scope.plan.id;

    const options = {
      promoCode: $scope.membershipDiscountForm.promoCode
    };

    return jsSdkMembership.membershipCheckout(planId, options)
      .then(result => {
        $scope.plan.promoCode = $scope.membershipDiscountForm.promoCode;
        $scope.plan.status = result.status;
        $scope.plan.statusDescription = result.statusDescription;
        $scope.plan.discounts = result.discounts;
        $scope.plan.billingIntervalPrice = result.price / result.billingInterval;
        $scope.plan.billingPrice = result.price;

        $scope.discountApplied = true;

        $scope.discountErrorMessage = null;

        $scope.discountFormSubmitted = false;
      })
      .catch(err => {
        $scope.discountErrorMessage = utilsService.errorMessage(err);
      });
  };

  $scope.loginConfig = {
    startState: 'newUser',
    completeProfile: false,
    compactLayout: true,
    success() {
      if (membershipService.isUserSubscribed()) {
        $state.go('app.membership.perks');
      }
    },
    error(resp) {
      $scope.loginErrorMessage = utilsService.errorMessage(resp);
    }
  };

  $scope.termsAccepted = function() {
    return _reduce($scope.plan.terms, function(acc, term) {
      return acc && term.accepted;
    }, true);
  };

  $scope.paymentUpdated = function(profile) {
    $scope.paymentProfile = profile;
  };

  $scope.complete = function() {
    $scope.purchasingErrorMessage = null;

    const user = jsSdkUser.getCurrentUser();

    if (!user || !user.id) {
      $scope.purchasingErrorMessage = 'Unknown User. Please log out and try again.';
      return;
    }

    if (!$scope.paymentProfile || !$scope.paymentProfile.id) {
      $scope.purchasingErrorMessage = 'Invalid payment information. Please update your credit card.';
      return;
    }

    if (!$scope.termsAccepted()) {
      $scope.purchasingErrorMessage = 'Please accept the above terms and conditions';
      return;
    }

    const options = {
      userId: user.id,
      planId: $scope.plan.id,
      paymentProfileId: $scope.paymentProfile.id,
      promoCode: $scope.plan.promoCode,
      affiliateId: $rootScope.affiliateId,
      trackingId: $rootScope.trackingId
    };

    $scope.completing = true;

    jsSdkMembership.create(options)
      .then(resp => {
        $scope.completing = false;

        const data = {
          plan: resp.planName,
          price: resp.price
        };

        tracking.trackEvent(SEGMENT_EVENTS.CompletedMembershipOrder, data);

        return jsSdkUser.me();
      })
      .then(currentUser => {
        _extend($rootScope.currentUser, currentUser);

        $state.go('app.membership.success');
      })
      .catch(err => {
        $scope.completing = false;

        $scope.purchasingErrorMessage = err.message;

        loggerService.error(err);

        $scope.purchasingErrorMessage = utilsService.errorMessage(err);
      });
  };

  jsSdkCity.list()
    .then(resp => {
      const limitTo = _map(membershipService.getCities(), 'slug');

      $scope.cities = _filter(resp, function(city) {
        return _includes(limitTo, city.slugName);
      });
    })
    .catch(err => {
      loggerService.error(err);
    });
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  '$state',
  '$stateParams',
  '$location',
  'utilsService',
  'metaTagService',
  'loggerService',
  'trackingService',
  'membershipService',
  'jsSdk.membership',
  'jsSdk.city',
  'jsSdk.user'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/membershipStart/membershipStartCtrl.js